import { TipoDocumentoPersonalEnum } from "../enums/TipoDocumentoPersonal.enum";


/**
 * Mapeo de los tipos de documentos personales a su descripción legible.
 */

export const TipoDocumentoPersonalDescripcion: Record<TipoDocumentoPersonalEnum, string> = {
    [TipoDocumentoPersonalEnum.CEDULA_IDENTIDAD]: 'Cédula de Identidad',
    [TipoDocumentoPersonalEnum.PASAPORTE]: 'Pasaporte',
    [TipoDocumentoPersonalEnum.LICENCIA_CONDUCIR]: 'Licencia de Conducir',
    [TipoDocumentoPersonalEnum.ACTA_NACIMIENTO]: 'Acta de Nacimiento',
};
/**
 * Obtiene la descripción legible de un tipo de documento personal.
 * @param tipo El tipo de documento personal.
 * @returns La descripción legible del tipo de documento.
 */
export const obtenerDescripcionTipoDocumento = (tipo: TipoDocumentoPersonalEnum): string => TipoDocumentoPersonalDescripcion[tipo] ?? 'Desconocido';

export interface PersonalDocumentUser {
    idPersonalDocumentUser: number;
    name: string;
    guidFile: string;
    idType: TipoDocumentoPersonalEnum;
    fileUrl: string;
    fileName: string;
    fileSize: number;
    uploadedAt: string;
}

